module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "hide-header-close": _vm.hideHeaderClose,
      "no-close-on-backdrop": _vm.noCloseOnBackdrop,
      "no-close-on-esc": _vm.noCloseOnEsc,
      "title": _vm.title,
      "size": _vm.size
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_vm._t("modal-body")], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_vm._t("modal-footer")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d0a3549"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Base/BaseDialogModal.vue
// module id = 1298
// module chunks = 1